import React from "react";

import styles from "./Spinner.module.scss";

const Spinner = ({ children, initialLineHeight }) => {
  return (
    <div
      className={[
        styles.container,
        initialLineHeight && styles.containerInitialLineHeight,
      ]}
    >
      <div className={styles.centerer}>
        <div className={styles.spinner} />
        <div>{children}</div>
      </div>
    </div>
  );
};
export default Spinner;
